import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import selectors from '../selectors/selectors.js';

const LeadModal = React.lazy(() => import('screens/leadModal/LeadModal'));

const LeadModalLoader = () => {
  const modal = useSelector(selectors.modal);
  const userIsLoggedIn = useSelector((state) => state.user.loggedIn);

  return (
    <>
      {String(modal) === 'true' && !!userIsLoggedIn && (
        <Suspense fallback={<div />}>
          <LeadModal />
        </Suspense>
      )}
    </>
  );
};

export default LeadModalLoader;
